export default __webpack_public_path__ + "static/media/location--5.9583f321.jpg";